import { createBrowserRouter } from 'react-router-dom'
import { wrapCreateBrowserRouterV6 } from '@sentry/react'

import AuthLayout from '@/components/layouts/AuthLayout'
import MainLayout from '@/components/layouts/MainLayout'
import RootPage from '@pages/Root'
import SignInPage from '@pages/SignIn/SignInPage'
import ForgotPasswordPage from '@pages/ForgotPassword/ForgotPasswordPage'
import ResetPasswordPage from '@pages/ResetPassword/ResetPasswordPage'
import SignoutPage from '@pages/SignoutPage'
import AccountPage from '@pages/Account/AccountPage'
import ProgressPage from '@pages/Progress/ProgressPage'
import InvitationPage from '@pages/Invitation/InvitationPage'
import AddStudentPage from '@pages/AddStudent/AddStudentPage'
import ManageStudentPage from '@pages/ManageStudent/ManageStudentPage'
import ManageContactPage from '@pages/ManageContactPage'
import ErrorBoundary from './components/ErrorBoundary'
import OnboardingPage from '@pages/OnboardingPage'

export const router = wrapCreateBrowserRouterV6(createBrowserRouter)([
  {
    path: '/:schoolSlug',
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        element: <RootPage />,
      },
      {
        element: <MainLayout />,
        children: [
          {
            path: 'onboarding',
            element: <OnboardingPage />,
          },
          {
            path: 'account',
            element: <AccountPage />,
          },
          {
            path: 'progress',
            element: <ProgressPage />,
          },
          {
            path: 'invite',
            element: <InvitationPage />,
          },
          {
            path: 'contact/:contactId',
            element: <ManageContactPage />,
          },
          {
            path: 'add-student',
            element: <AddStudentPage />,
          },
          {
            path: 'student/:studentId',
            element: <ManageStudentPage />,
          },
        ],
      },
      {
        element: <AuthLayout />,
        children: [
          {
            path: 'signin',
            element: <SignInPage />,
          },
          {
            path: 'signout',
            element: <SignoutPage />,
          },
          {
            path: 'forgot-password',
            element: <ForgotPasswordPage />,
          },
          {
            path: 'reset-password',
            element: <ResetPasswordPage />,
          },
        ],
      },
    ],
  },

  {
    path: '*',
    loader: () => {
      // send user to BAF home page
      window.location.replace('https://www.booksarefun.com')
      return null // Return null as the loader won't resolve a value for rendering
    },
    element: null,
  },
])
